<template>
<div>
<div v-for="item in field" :key="item.key">
  <div class="parent-wrapper">
<a :href="`/jobs/${getSlugLink(item.en)}/1`" target="_blank">
      <span class="additional_tag parent">
        {{ item.default }}
      </span>
    </a>
  </div>

        <div class="to">
        >
        </div>
      <div v-if="item.children" class="d-inline-block child-wrapper">
      <a v-for="child in item.children" :key="child.key" :href="`/jobs/${getSlugLink(item.en)}/${getSlugLink(child.en)}/1`" target="_blank">
        <div class="additional_tag child">
          {{ child.default }}
        </div>
      </a>
      </div>
    </div>
</div>
</template>

<script>
import commonHelper from '~/assets/js/commonHelper.js'

export default {
  props: {
    field: {
      default: null,
      type: [Array, Object]
    }
  },
  data: function() {
    return {
      comFuc: commonHelper
    }
  },
  methods: {
    getSlugLink(title) {
      const slug = commonHelper.getSlug(title)
      return slug
    }
  }
}
</script>
<style lang="scss">
.parent-wrapper{
    max-width: 49%;
    display: inline-block;
    vertical-align: top;
}
.to{
    max-width: 5%;
    height: 100%;
    display: inline-block;
    vertical-align: top;
    padding-top: 5px;
    padding-right: 5px;
}
.child-wrapper{
    max-width: 47%;
    display: inline-block;
}
</style>
